import AdminAside from '@this/impl/pages/admin/aside/admin';
import React from 'react';
import { RouteProps } from 'react-router-dom';

const aside: RouteProps[] = [
	{ path: '/admin', element: <AdminAside /> },
	{ path: '/admin/*', element: <AdminAside /> },
];

export default aside;
